import FeedbackError from 'components/FeedbackError/styled';

export default FeedbackError;
